import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import UiKitCheckbox from '@rio-cloud/rio-uikit/Checkbox';
import type { ChangeEvent, PropsWithChildren } from 'react';

interface CheckboxProps {
    value: boolean;
    disabled?: boolean;
    className?: string;
    messageId?: string;
    error?: string;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

export const Checkbox = (props: PropsWithChildren<CheckboxProps>) => {
    const { value, disabled, className, messageId, onChange, error } = props;

    const cs = {
        disabled,
        'form-group': true,
        'has-error has-feedback': error,
    };

    return (
        <div className={classNames(className)}>
            <div className={classNames(cs)}>
                <UiKitCheckbox checked={value} disabled={disabled} onChange={onChange}>
                    {messageId && <FormattedMessage id={messageId} />}
                    {props.children}
                </UiKitCheckbox>
            </div>
        </div>
    );
};
